module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-41.de9bb94e.png";